<template>
  <div class="highWayPrice" v-loading="importLoading">
    <div class="nav">
      <el-form :model="form" label-width="80px" :inline="true" class="demo-form-inline flex1">
        <el-form-item label="合同名称:">
          <el-input v-model="form.contractName" size="mini" placeholder="请选输入合同名称" />
        </el-form-item>
        <el-form-item label="合同编号:">
          <el-input v-model="form.contractCode" size="mini" placeholder="请选输入合同编号" />
        </el-form-item>
        <el-form-item label="供应商:">
          <el-input v-model="form.highwayName" size="mini" placeholder="请选输入供应商" />
        </el-form-item>
        <el-form-item label="起始地:">
          <el-input
            placeholder="请输入起始地"
            size="mini"
            v-model="form.startAddressName"></el-input>
        </el-form-item>
        <el-form-item label="目的地:">
          <el-input placeholder="请输入目的地" size="mini" v-model="form.endAddressName"></el-input>
        </el-form-item>
        <el-form-item label="车型:">
          <el-input placeholder="请输入车型" size="mini" v-model="form.customerCarName"></el-input>
        </el-form-item>
        <el-form-item label="状态:">
          <el-select v-model="form.status" filterable size="mini" placeholder="请选择状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="待生效" value="0"></el-option>
            <el-option label="生效中" value="1"></el-option>
            <el-option label="已失效" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算方式:">
          <el-select v-model="form.type" filterable size="mini" placeholder="请选择结算方式">
            <el-option label="全部" value=""></el-option>
            <el-option label="合同" value="0"></el-option>
            <el-option label="预结算" value="1"></el-option>
            <el-option label="预估" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="录入人员:">
          <el-input placeholder="请输入录入人员" size="mini" v-model="form.createByName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
          <el-button size="small" type="primary" @click="addBtn">新增</el-button>
          <el-button size="small" type="primary" @click="batchEnable">启用</el-button>
          <el-button size="small" type="danger" @click="onClickDeletes">批量删除</el-button>
          <el-button size="small" class="resetBtn" @click="onClickStops">批量停用</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="content">
      <div class="tableContainer">
        <div style="display: flex; justify-content: flex-end">
          <span
            class="el-icon-download el-icon--right"
            style="
              cursor: pointer;
              font-size: 16px;
              margin-right: 20px;
              color: rgba(51, 136, 255, 1);
              display: flex;
              align-items: center;
            "
            @click="download"
            >模板下载</span
          >
          <span style="cursor: pointer; margin-right: 20px">
            <el-upload
              ref="upload"
              class="upload-demo"
              style="color: rgba(51, 136, 255, 1)"
              :action="uploadUrl"
              :auto-upload="true"
              :show-file-list="false"
              :data="uploadData"
              :on-success="planOnSuccess"
              :before-upload="beforeUpload">
              <i class="el-icon-upload el-icon--right">批量导入</i>
            </el-upload>
          </span>
          <span
            style="cursor: pointer; font-size: 16px; color: rgba(51, 136, 255, 1)"
            @click="exportData"
            >导出数据</span
          >
        </div>
        <el-table
          ref="tableRef"
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          :header-cell-style="{
            color: '#3B3B3B',
            'font-size': '13px',
            height: '48px',
            background: '#E8E8E8',
          }"
          @selection-change="selectionChange"
          :row-style="rowStyle">
          <el-table-column
            type="selection"
            align="center"
            width="55"
            :reserve-selection="true"></el-table-column>
          <el-table-column label="序号" align="center" width="50px">
            <div slot-scope="scope">{{ scope.$index + 1 }}</div>
          </el-table-column>
          <el-table-column
            prop="contractName"
            label="合同名称"
            align="center"
            width="150"
            show-overflow-tooltip />
          <el-table-column
            prop="contractCode"
            label="合同编号"
            align="center"
            width="150"
            show-overflow-tooltip />
          <el-table-column
            prop="highwayName"
            label="供应商"
            width="150"
            show-overflow-tooltip
            align="center" />
          <el-table-column label="起运地" width="280" align="center">
            <template slot-scope="scope">
              {{
                `${scope.row.startAddressName}  ${
                  scope.row.startPort ? '【' + scope.row.startPort + '】' : ''
                }`
              }}
            </template>
          </el-table-column>
          <el-table-column label="目的地" width="280" align="center">
            <template slot-scope="scope">
              {{
                `${scope.row.endAddressName}  ${
                  scope.row.endPort ? '【' + scope.row.endPort + '】' : ''
                }`
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="customerCarName"
            label="车型"
            width="120"
            show-overflow-tooltip
            align="center" />
          <el-table-column prop="taxRate" label="税率%" align="center" width="80" />
          <el-table-column prop="contractPrice" label="合同单价" align="center" width="90" />
          <!-- <el-table-column prop="prepareType" label="预结算方式" align="center" width="100">
            <template slot-scope="scope">{{scope.row.prepareType|prepareTypeFormat}}</template>
          </el-table-column> -->
          <el-table-column
            prop="preparePrice"
            label="预结算单价"
            show-overflow-tooltip
            width="90"
            align="center">
            <template slot-scope="scope">
              {{
                scope.row.preparePrice
                  ? scope.row.preparePrice != 0
                    ? scope.row.preparePrice
                    : ''
                  : scope.row.isPerfectPrice == 1
                  ? '--'
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column prop="estimatePrice" label="预估单价" align="center" width="80" />
          <el-table-column
            prop="createTime"
            label="创建时间"
            show-overflow-tooltip
            width="150"
            align="center">
            <template slot-scope="scope">{{ scope.row.createTime | getCreatTime }}</template>
          </el-table-column>
          <el-table-column
            prop="createByName"
            label="录入人员"
            show-overflow-tooltip
            width="150"
            align="center" />
          <el-table-column
            prop="startDate"
            label="有效起始"
            align="center"
            width="110" >
            <template slot-scope="scope">{{ scope.row.startDate | getCreatTime }}</template>
          </el-table-column>
          <el-table-column
            prop="endDate"
            label="结束时间"
            align="center"
            width="110" >
            <template slot-scope="scope">{{ scope.row.endDate | getCreatTime }}</template>
          </el-table-column>
          <el-table-column prop="status" label="状态" align="center" width="80">
            <template slot-scope="scope">{{ scope.row.status | statusFormat }}</template>
          </el-table-column>
          <el-table-column label="操作" width="380" align="center">
            <template slot-scope="scope">
              <div>
                <el-button
                  size="mini"
                  class="searchBtn"
                  type="primary"
                  @click="detailClick(scope.row.id)"
                  >详情
                </el-button>
                <el-button
                  v-if="scope.row.status == 0 || scope.row.status == 1"
                  size="mini"
                  type="primary"
                  :loading="scope.row.changeLoad"
                  @click="changeClick(scope.row.id, scope.row.status,scope.row)"
                  class="yellow-bg">
                  {{ scope.row.status == 0 ? '修改' : '修改车型' }}
                </el-button>
                <el-button
                  v-if="scope.row.status == 0"
                  size="mini"
                  type="primary"
                  @click="enableClick(scope.row.id)"
                  >启用
                </el-button>
                <el-button
                  v-if="scope.row.status == 1"
                  size="mini"
                  type="danger"
                  @click="stopClick(scope.row.id)"
                  >停用
                </el-button>
<!--                <el-button size="mini" class="yellow-bg" type="danger" @click="recordBtn(scope.row)"-->
<!--                  >补录合同-->
<!--                </el-button>-->
                <el-button size="mini" type="info" @click="deleteClick(scope.row.id)"
                  >删除
                </el-button>
                <!--                <el-button v-if="scope.row.status== 1"-->
                <!--                           size='mini' type='primary'-->
                <!--                           @click='changePriceOpenDialog(scope.row)'>修改金额-->
                <!--                </el-button>-->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer" style="margin-top: 20px">
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          :current-page.sync="form.page"
          :page-size="form.rows" />
      </div>
    </div>

    <el-dialog title="详情" :visible.sync="detailDialogVisible" width="723px" center>
      <div class="detail">
        <!-- <div class="tabs">
          <div @click="planType = 0" class="left" :class="{ active: planType === 0 }">起止区域信息</div>
          <div @click="planType = 1" class="right" :class="{ active: planType === 1 }">托运商价格信息</div>
        </div> -->
        <el-form :model="detailData" label-position="left">
          <div class="baseInfo" v-if="planType === 0">
            <div class="baseInfoTitle">
              <div class="line" />
              <span>基础信息</span>
              <p>{{ detailData.state }}</p>
            </div>
            <div class="baseInfoContent">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="供应商:">
                    <span>{{ detailData.highwayName }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="线路名称:">
                    <span>{{ detailData.lineName }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="合同名称:">
                    <span>{{ detailData.contractName }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="合同编号:">
                    <span>{{ detailData.contractCode }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="起运地:">
                    <span v-if="!detailData.startPortId">{{ detailData.startPosition }}</span>
                    <span v-else>{{ detailData.startPosition }}【{{ detailData.startPort }}】</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="交车地:">
                    <span v-if="!detailData.endPortId">{{ detailData.endPosition }}</span>
                    <span v-else>{{ detailData.startPosition }}【{{ detailData.endPort }}】</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="有效期始:">
                    <span>{{ detailData.startDate }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="结束时间:">
                    <span>{{ detailData.endDate }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="baseInfoTitle">
              <div class="line" />
              <span>价格信息</span>
            </div>
            <div class="baseInfoContent">
              <el-form label-position="left">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="税率:">
                      <span>{{ detailData.taxRate ? detailData.taxRate + '%' : '无' }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="合同价:">
                      <span>{{
                        detailData.contractPrice ? detailData.contractPrice + '元' : '无'
                      }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="预结算价:">
                      <span>{{
                        detailData.preparePrice ? detailData.preparePrice + '元' : '无'
                      }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="预估价:">
                      <span>{{
                        detailData.estimatePrice ? detailData.estimatePrice + '元' : '无'
                      }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <div class="operation">
              <div class="operationTitle">
                <div class="line" />
                <span>补录合同</span>
              </div>
              <div class="operationTable">
                <el-table
                  :data="contractTableList"
                  border
                  :header-cell-style="{ background: '#E8E8E8', color: '#3B3B3B', height: '35px' }">
                  <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                    align="center"></el-table-column>
                  <el-table-column
                    property="codeNumber"
                    label="合同编号"
                    min-width="150"
                    align="center" />
                  <el-table-column
                    property="contractName"
                    label="合同名称"
                    min-width="150"
                    align="center" />
                  <el-table-column
                    property="typeName"
                    label="合同类型"
                    min-width="100"
                    align="center" />
                  <el-table-column
                    prop="supplementaryContract.rate"
                    label="税率"
                    min-width="150"
                    align="center" />
                  <el-table-column
                    prop="supplementaryContract.taxContractPrice"
                    label="含税合同价"
                    min-width="150"
                    align="center" />
                  <el-table-column
                    prop="supplementaryContract.contractPrice"
                    label="不含税合同价"
                    min-width="150"
                    align="center" />
                  <el-table-column
                    property="startDate"
                    label="开始日期"
                    min-width="100"
                    :formatter="getDate"
                    align="center" />
                  <el-table-column
                    property="endDate"
                    label="结束日期"
                    min-width="100"
                    :formatter="getDate"
                    align="center" />
                  <el-table-column width="200px" label="操作" align="center" fixed="right">
                    <template slot-scope="scope">
                      <el-button type="danger" size="small" @click="deleteTableClick(scope.row)"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="baseInfoTitle">
              <div class="line" />
              <span>适配车型</span>
            </div>
            <div class="baseInfoContent">
              <el-table
                :data="detailData.carModelList"
                style="width: 100%"
                border
                :header-cell-style="{
                  color: '#3B3B3B',
                  'font-size': '13px',
                  height: '35px',
                  background: '#E8E8E8',
                }"
                :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }"
                ref="carTableRef">
                <el-table-column
                  type="index"
                  label="序号"
                  width="50"
                  align="center"></el-table-column>
                <el-table-column label="品牌" prop="brandName" align="center" />
                <el-table-column label="型号" prop="modelName" align="center" />
                <el-table-column label="状态" prop="status" align="center">
                  <template slot-scope="scope">{{ scope.row.status | statusFormat }}</template>
                </el-table-column>
              </el-table>
            </div>
            <div class="operation">
              <div class="operationTitle">
                <div class="line" />
                <span>操作信息</span>
              </div>
              <div class="operationTable">
                <el-table
                  :data="detailData.operateRecordList"
                  border
                  :header-cell-style="{ background: '#E8E8E8', color: '#3B3B3B', height: '35px' }">
                  <el-table-column
                    prop="createTime"
                    label="操作时间"
                    align="center"
                    width="160px" />
                  <el-table-column prop="operateType" label="操作类型" align="center" />
                  <el-table-column prop="operationName" label="操作人" align="center" />
                  <el-table-column prop="remark" label="备注" align="center" />
                </el-table>
              </div>
            </div>
          </div>
          <!-- <div class="baseInfo" v-if="planType===1">
            <div class="operation">
              <div class="operationTable">
                <el-table
                  :data="detailData.basics"
                  style="width: 100%"
                  border
                  :header-cell-style="{color:'#3B3B3B','font-size':'13px',height:'35px',background:'#E8E8E8'}"
                  :cell-style="{'color':'#7F7F7F','font-size':'13px'}"
                  ref="carTableRef">
                  <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
                  <el-table-column label="车型" prop="customerCarName" show-overflow-tooltip  width="150" align="center" />
                  <el-table-column label="税率%" prop="taxRate" align="center" />
                  <el-table-column label="合同价格" prop="contractPrice" align="center" />
                  <el-table-column label="预结算价格" prop="preparePrice" align="center"/>
                  <el-table-column label="预结算方式" prop="prepareType" align="center">
                    <template slot-scope="scope">{{scope.row.prepareType|prepareTypeFormat}}</template>
                  </el-table-column>
                  <el-table-column label="预估价格" prop="estimatePrice" align="center" />
                </el-table>
              </div>
            </div>
          </div> -->
        </el-form>
      </div>
    </el-dialog>
    <!-- <el-dialog title="修改合同" :visible.sync="modifyflag"  width='623px' center>
      <list-modify @modifyclose="modifyshow"></list-modify>
    </el-dialog> -->
    <el-dialog
      :title="dataD.showNumber === 1 ? '添加公路价格' : '修改公路价格'"
      :visible.sync="addflag"
      width="800px"
      center
      @close="dialogClose">
      <highWayAdd
        @addclose="addshow"
        :dataD="dataD"
        :addType="addType"
        :editType="editType"
        ref="highWayAdd"></highWayAdd>
    </el-dialog>
    <!-- 完善价格 -->
    <el-dialog
      title="完善价格"
      :visible.sync="priceSetVisible"
      :close-on-click-modal="false"
      append-to-body
      width="910px">
      <div style="padding: 20px">
        <div-border label="价格设置">
          <el-form :model="completeDate" label-width="100px">
            <el-form-item
              label="结算方式："
              style="margin-top: 15px"
              v-if="completeDate.isWay != 1">
              <span style="display: inline-block; width: 320px">
                <el-radio-group v-model="completeDate.type">
                  <el-radio :label="0">暂无</el-radio>
                  <el-radio :label="1">合同价格</el-radio>
                  <el-radio v-if="completeDate.isWay == -1" :label="2">预结算价格</el-radio>
                </el-radio-group>
              </span>
              <span
                style="
                  display: inline-block;
                  width: calc(100% - 320px);
                  text-align: right;
                  padding-right: 15px;
                ">
                <el-input
                  size="small"
                  v-if="completeDate.type !== 0"
                  v-model="completeDate.price"
                  placeholder="请输入价格" />
              </span>
            </el-form-item>
            <el-form-item
              label="预估价："
              v-if="completeDate.isEst"
              style="width: calc(100% - 250px); display: inline-block"
              :style="completeDate.isWay == 1 ? 'margin-top:15px;' : ''">
              <el-input size="small" v-model="completeDate.estimate" placeholder="请输入预估价" />
            </el-form-item>
            <el-form-item
              label-width="0px"
              style="width: 250px; text-align: right; display: inline-block"
              :style="!completeDate.isEst ? 'width:100%;' : ''">
              <el-button
                size="small"
                class="searchBtn"
                :loading="completeLoad"
                @click="priceSetConfirm"
                >确定
              </el-button>
              <el-button size="small" class="resetBtn" @click="priceSetVisible = false"
                >取消
              </el-button>
            </el-form-item>
          </el-form>
        </div-border>
        <div-border
          :is-need="true"
          v-if="completeDate.isWay != 1 && completeDate.type != 0"
          label="选择合同"
          style="padding: 29px 20px">
          <div class="nav">
            <div class="navContainer">
              <p>合同名称：</p>
              <el-input
                v-model="condition.contractName"
                size="mini"
                style="width: 150px"
                placeholder="请输入合同名称" />
            </div>
            <div class="navContainer">
              <p>合同编号：</p>
              <el-input
                v-model="condition.codeNumber"
                size="mini"
                style="width: 150px"
                placeholder="请输入合同编号" />
            </div>
            <div class="navContainer">
              <p>签约单位：</p>
              <el-input
                v-model="condition.companyName"
                size="mini"
                style="width: 150px"
                placeholder="请输入签约单位" />
            </div>
            <div class="navBtn">
              <el-button size="small" class="searchBtn" @click="_contractPageList">查询</el-button>
              <el-button size="small" class="resetBtn" @click="resetComplete">重置</el-button>
            </div>
          </div>
          <el-table
            :data="contractData"
            highlight-current-row
            border
            ref="contractTable"
            @current-change="contractChange"
            v-loading="contractLoad"
            :header-cell-style="{
              color: '#3B3B3B',
              'font-weight': '700',
              padding: '0px',
              'font-size': '13px',
              height: '35px',
              background: '#E8E8E8',
            }"
            :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }">
            <el-table-column type="index" width="50" />
            <el-table-column
              property="codeNumber"
              label="合同编号"
              min-width="150"
              align="center" />
            <el-table-column
              property="contractName"
              label="合同名称"
              min-width="150"
              align="center" />
            <el-table-column property="typeName" label="合同类型" min-width="100" align="center" />
            <el-table-column
              property="companyName"
              label="签约单位"
              min-width="150"
              align="center" />
            <el-table-column
              property="startDate"
              label="开始日期"
              min-width="100"
              :formatter="getDate"
              align="center" />
            <el-table-column
              property="endDate"
              label="结束日期"
              min-width="100"
              :formatter="getDate"
              align="center" />
          </el-table>
          <div style="margin-top: 20px">
            <el-pagination
              background
              :page-sizes="[10, 20, 30, 40]"
              layout="total, sizes, prev, pager, next, jumper"
              :total="conditionTotal"
              @size-change="completeSizeChange"
              @current-change="completeCurrentChange"
              :current-page.sync="condition.page"
              :page-size="condition.rows" />
          </div>
        </div-border>
      </div>
    </el-dialog>
    <!--  补录合同  -->
    <el-dialog
      title="补录合同"
      :visible.sync="contractVisible"
      :close-on-click-modal="false"
      append-to-body
      width="910px"
      @close="cancel">
      <div-border label="价格设置">
        <div class="nav" style="margin-top: 10px">
          <div class="navContainer" style="width: 300px">
            <p style="width: 100px">不含税金额：</p>
            <el-input
              v-model.number="condition.price"
              size="mini"
              style="width: 150px"
              placeholder="请输入不含税金额" />
          </div>
          <div class="navContainer">
            <p>含税金额：</p>
            <el-input
              v-model.number="condition.taxPrice"
              size="mini"
              style="width: 150px"
              placeholder="请输入含税金额" />
          </div>
          <div class="navBtn">
            <el-button size="small" class="searchBtn" @click="contractConfirm">确定</el-button>
            <el-button size="small" class="resetBtn" @click="cancel">取消</el-button>
          </div>
        </div>
      </div-border>
      <div-border label="选择合同">
        <el-table
          :data="contractTableData"
          highlight-current-row
          border
          ref="contractTable"
          @current-change="contractChange"
          v-loading="contractLoad"
          style="margin-top: 10px"
          :header-cell-style="{
            color: '#3B3B3B',
            'font-weight': '700',
            padding: '0px',
            'font-size': '13px',
            height: '35px',
            background: '#E8E8E8',
          }"
          :cell-style="{ color: '#7F7F7F', 'font-size': '13px' }">
          <el-table-column type="index" width="50" />
          <el-table-column property="codeNumber" label="合同编号" min-width="150" align="center" />
          <el-table-column
            property="contractName"
            label="合同名称"
            min-width="150"
            align="center" />
          <el-table-column property="typeName" label="合同类型" min-width="100" align="center" />
          <el-table-column property="companyName" label="签约单位" min-width="150" align="center" />
          <el-table-column
            property="startDate"
            label="开始日期"
            min-width="100"
            :formatter="getDate"
            align="center" />
          <el-table-column
            property="endDate"
            label="结束日期"
            min-width="100"
            :formatter="getDate"
            align="center" />
        </el-table>
        <div style="margin-top: 20px">
          <el-pagination
            background
            :page-sizes="[10, 20, 30, 40]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="contractTotal"
            @size-change="addContractSizeChange"
            @current-change="addContractCurrentChange"
            :current-page.sync="page"
            :page-size="row" />
        </div>
      </div-border>
    </el-dialog>
    <changePrice @success="searchBtn" ref="changePriceRef" />
  </div>
</template>

<script>
  import highWayAdd from '@/views/financial/price/incomeLinePrice/components/highWayAdd';
  import {
    highwayLinePageList,
    highwayLineSelectList,
    highwayDetail,
    highwayEnable,
    contractPageList,
    completeHighPrice,
    highwayDelete,
    getContractInfo,
    getContractPageList,
    addContract,
    deleteContractInfo,
  } from '@/service/financial';
  import { publicSelectLine } from '@/service/vehiclelog';
  import { getImport, getImportUrl } from '@/service/getIP';
  import divBorder from '@/components/divBorder';
  import { formatDateTime, getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import changePrice from '@/components/changePrice';
  import { getPageList } from '@/service/account';

  export default {
    components: {
      highWayAdd,
      divBorder,
      changePrice,
    },

    data() {
      return {
        importLoading: false,
        form: {
          contractName: '',
          contractCode: '',
          highwayName: '',
          startAddressName: '',
          endAddressName: '',
          status: '',
          createByName: '',
          customerCarName: '',
          type: '',
          page: 1,
          rows: 10,
        },
        total: 0,
        tableLoad: false,
        changeLoad: false,
        TableDatas: [],
        activeName: 'default',
        detailDialogVisible: false,
        lineOption: [],
        supplierOption: [],
        detailData: {},
        planType: 0,
        operationData: [],
        addflag: false,
        //1 为添加，2为修改
        dataD: {
          showNumber: 1,
          user_id: '',
          data: {},
        },
        addType: false,
        uploadUrl: '', //导入地址
        uploadData: { mFile: '' }, // 导入数据

        //修改金额
        dialogDetailVisible: false,
        dialogNames: '',
        changePriceId: '',

        // 完善价格
        priceSetVisible: false, // 弹窗显隐
        completeDate: {
          id: '',
          type: 0, // 结算方式
          price: '', // 价格
          estimate: '', // 预估价
        },
        completeLoad: false,
        condition: {
          price: '',
          taxPrice: '',
          priceInfoId: '',
          rate: '',
        },
        pricetData: {},
        page: 1,
        rows: 10,
        row: 10,
        contractTotal: 0,
        conditionTotal: 0,
        contractLoad: false,
        contractData: [],
        contractTableData: [],
        selectContract: {
          id: '',
          codeNumber: '',
          companyName: '',
          startDate: '',
          endDate: '',
        },
        editType: 0,
        checkTableData: [],
        contractVisible: false,
        contractTableList: [],
      };
    },
    filters: {
      transportTypeFormat(value) {
        switch (value) {
          case 1:
            return '公路';
          case 2:
            return '水路';
        }
      },
      statusFormat(value) {
        switch (value) {
          case 0:
            return '待生效';
          case 1:
            return '生效中';
          case 2:
            return '已失效';
        }
      },
      prepareTypeFormat(value) {
        switch (value) {
          case 1:
            return '固定';
          case 2:
            return '比例';
        }
      },
      getCreatTime(val) {
        if (val) {
          return formatDateTime(val, 'yyyy-mm-dd hh:ii:ss');
        } else {
          return '';
        }
      },
    },
    mounted() {
      this.$nextTick(() => {
        // this._lineConsignorLineList();
      });
    },
    created() {
      this.uploadUrl = getImportUrl('/price/highwayLine/batchHigWayLinePrice');
    },
    methods: {
      async batchEnable() {
        if (this.checkTableData === null || this.checkTableData.length === 0)
          return this.$message.warning('请选择数据后启用！');
        this.$confirm('确认要启用选中线路价格吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            console.log(1212);
            const params = [];
            this.checkTableData.forEach(item => {
              params.push(item.id);
            });
            let res = await highwayEnable({
              id: params.join(','),
              status: 1,
            });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.$refs.tableRef.clearSelection();
            this.checkTableData = [];
            await this._lineConsignorLineList();
          })
          .catch(() => {});
      },
      selectionChange(selectionRow) {
        this.checkTableData = selectionRow;
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      // 分页查询
      async _lineConsignorLineList() {
        this.tableLoad = true;
        let res = await highwayLinePageList(this.form);
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      // 查询线路
      async _publicSelectLine(type) {
        let res = await publicSelectLine({
          type: type,
        });
        if (res.status !== 0) return this.$message.error(res.message);
        this.lineOption = res.data;
      },
      // 供应商
      async _supplierSelectList() {
        let res = await highwayLineSelectList();
        if (res.status !== 0) return this.$message.error(res.message);
        this.supplierOption = res.data;
      },

      searchBtn() {
        this.form.page = 1;
        this._lineConsignorLineList();
      },
      resetBtn() {
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = '';
        }
        this.form.page = 1;
        this.form.rows = 10;
      },
      addBtn() {
        this.editType = 0;
        this.dataD.showNumber = 1;
        this.addType = false;
        this.addflag = true;
        this.$nextTick(() => {
          this.$refs.highWayAdd._publicSelectLine(1);
          this.$refs.highWayAdd._customerInfoSelectList(); //公路供应商
          this.$refs.highWayAdd._getCarSerieList();
        });
      },
      contractSizeChange(row) {
        this.form.rows = row;
        this.$refs.tableRef.clearSelection();
        this.checkTableData = [];
        this._lineConsignorLineList();
      },
      contractCurrentChange(page) {
        this.form.page = page;
        this._lineConsignorLineList();
      },
      // 详情
      async detailClick(id) {
        this.detailDialogVisible = true;
        let res = await highwayDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = res.data;
        // 运输线路
        let res1 = await publicSelectLine({ type: 1 });
        if (res1.status !== 0) return this.$message.error(res1.message);
        if (res1.data.length > 0) {
          res1.data.forEach(item => {
            if (item.id == this.detailData.lineId) {
              this.detailData.startPosition = item.start_address_name;
              this.detailData.endPosition = item.end_address_name;
              this.detailData.startPortId = item.departure_port_id;
              this.detailData.startPort = item.departure_port;
              this.detailData.endPortId = item.arrive_port_id;
              this.detailData.endPort = item.arrive_port;
            }
          });
          let res2 = await getContractInfo(id);
          if (res2.status !== 0) return this.$message.error(res2.message);
          this.contractTableList = res2.data;
        }
      },
      //详情-补录合同-删除
      deleteTableClick(row) {
        this.$confirm('确认删除当前合同吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          let obj = {
            priceInfoId: row.supplementaryContract.priceInfoId,
            contractId: row.supplementaryContract.contractId,
            type: 3,
          };
          const res = await deleteContractInfo(obj);
          if (res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this.detailDialogVisible = false;
        });
      },
      async changeClick(id, type) {
        this.editType = type;
        let res = await highwayDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.dataD.data = res.data;
        this.dataD.showNumber = 2;
        this.dataD.user_id = id;
        this.addflag = true;
        this.$nextTick(() => {
          this.$refs.highWayAdd._customerInfoSelectList(); //公路供应商
          this.$refs.highWayAdd._getCarSerieList();
          this.$refs.highWayAdd.getRevise();
        });
        this.addType = false;
      },
      // 启用
      enableClick(id) {
        this.$confirm('确认要启用线路价格吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let obj = {
              id: id,
              status: 1,
            };
            let res = await highwayEnable(obj);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this._lineConsignorLineList();
          })
          .catch(() => {});
      },
      // 停用
      stopClick(id) {
        this.$confirm('确认要停用线路价格吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let obj = {
              id: id,
              status: 2,
            };
            let res = await highwayEnable(obj);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this._lineConsignorLineList();
          })
          .catch(() => {});
      },
      // 批量停用
      onClickStops() {
        if (this.checkTableData.length > 0) {
          this.$confirm('确认要停用线路价格吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              this.tableLoad = true;
              const ids = this.checkTableData.map(item => item.id).join(',');
              let res = await highwayEnable({
                id: ids,
                status: 2,
              });
              if (res.status !== 0) {
                this.$message.error(res.message);
                this.tableLoad = false;
                return
              }
              this.$message.success(res.message);
              this.$refs.tableRef.clearSelection();
              this.checkTableData = [];
              this._lineConsignorLineList();
            })
            .catch(() => {});
        } else {
          this.$message({
            message: '请先选择要停用线路价格',
            type: 'warning',
          });
        }
      },
      // 补录合同
      recordBtn(row) {
        this.condition.id = row.id;
        this.companyId = row.highwayId;
        (this.condition.rate = row.taxRate), (this.contractPrice = row.contractPrice);
        this.preparePrice = row.preparePrice;
        this.startDate = row.startDate;
        this.endDate = row.endDate;
        this.selectContract = '';
        this.getContractPage();
      },
      //查询
      async getContractPage() {
        let obj = {
          id: this.condition.id,
          companyId: this.companyId,
          rate: this.condition.rate,
          contractPrice: this.contractPrice ? this.contractPrice : '',
          preparePrice: this.preparePrice ? this.preparePrice : '',
          page: this.page,
          row: this.row,
        };
        this.contractLoad = true;
        let res = await getContractPageList(obj);
        this.contractLoad = false;
        if (res.status !== 0) {
          this.$message.error(res.message);
          this.contractVisible = false;
        } else {
          this.contractVisible = true;
          this.contractTableData = res.data.records;
          this.contractTotal = res.data.total;
        }
      },
      async contractConfirm() {
        if (!this.condition.price || this.condition.price === '') {
          return this.$message.warning('请输入不含税金额！');
        }
        if (!this.condition.taxPrice || this.condition.taxPrice === '') {
          return this.$message.warning('请输入含税金额！');
        }
        if (!this.selectContract.id || this.selectContract.id === '') {
          return this.$message.warning('请选择合同！');
        }
        let obj = {
          type: 3,
          rate: this.condition.rate,
          taxPrice: this.condition.taxPrice,
          price: this.condition.price,
          priceInfoId: this.condition.id,
          contractId: this.selectContract.id,
          startDate: this.startDate,
          endDate: this.endDate,
        };
        const res = await addContract(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.contractVisible = false;
      },
      cancel() {
        this.condition.price = '';
        this.condition.taxPrice = '';
        this.contractVisible = false;
      },
      // 删除
      deleteClick(id) {
        this.$confirm('确认要删除线路价格吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await highwayDelete(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this._lineConsignorLineList();
          })
          .catch(() => {});
      },
      onClickDeletes() {
        // console.log(this.checkTableData);
        if (this.checkTableData.length > 0) {
          this.$confirm('确认要删除线路价格吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              this.tableLoad = true;
              let ids = '';
              this.checkTableData.forEach(rowData => {
                ids = ids + rowData['id'] + ',';
              });
              ids = ids.substring(0, ids.lastIndexOf(','));
              let res = await highwayDelete(ids);
              if (res.status !== 0) {
                this.$message.error(res.message);
                this.tableLoad = false;
                return;
              }
              this.$message.success(res.message);
              this.$refs.tableRef.clearSelection();
              this.checkTableData = [];
              this._lineConsignorLineList();
            })
            .catch(() => {});
        } else {
          this.$message({
            message: '请先选择数据！',
            type: 'warning',
          });
        }
      },
      addshow(val) {
        this.addType = false;
        this.addflag = val;
        // this._lineConsignorLineList()
      },
      dialogClose() {
        this.$refs.highWayAdd.dialogClose();
      },
      // 时间长度处理
      getDate(row, column, cellValue) {
        if (cellValue) {
          return cellValue.substring(0, 10);
        } else {
          return '';
        }
      },
      addContractSizeChange(rows) {
        this.row = rows;
        this.getContractPage();
      },
      addContractCurrentChange(page) {
        this.page = page;
        this.getContractPage();
      },
      //修改金额-打开对话框
      changePriceOpenDialog(row) {
        this.$refs.changePriceRef.dialogOpen(row.id, 4);
      },
      /**
       * 完善价格
       */
      // 完善价格 —— 打开弹窗
      complete(row) {
        this.condition.page = 1;
        this.completeDate = {
          id: row.id,
          isWay: row.isPerfectPrice,
          isEst: row.estimatePrice ? false : true,
          highwayId: row.highwayId,
          type: 0,
          price: '',
          estimate: row.estimatePrice || '',
        };
        if (row.isPerfectPrice == 0) {
          this.completeDate.price = row.contractPrice;
          this.completeDate.type = 1;
        }
        if (row.isPerfectPrice == -1) {
          this.completeDate.type = 2;
        }
        if (row.contractId) {
          this.selectContract = { id: row.contractId };
        } else {
          this.selectContract = '';
        }
        this.priceSetVisible = true;
        this._contractPageList();
      },
      // 完善价格 —— 合同分页查询
      // async _contractPageList() {
      //   let obj = {
      //     ...this.condition,
      //     id: this.completeDate.highwayId,
      //   };
      //   this.contractLoad = true;
      //   let res = await contractPageList(obj);
      //   this.contractLoad = false;
      //   if (res.status !== 0) return this.$message.error(res.message);
      //   this.contractData = res.data.records;
      //   this.total = res.data.total || 0;
      //   if (this.selectContract.id && this.contractData.length > 0) {
      //     this.contractData.forEach(item => {
      //       if (item.id == this.selectContract.id) {
      //         if (this.$refs.contractTable) this.$refs.contractTable.setCurrentRow(item);
      //       }
      //     });
      //   }
      // },
      // 完善价格 —— 重置
      resetComplete() {
        for (let key in this.condition) {
          if (key == 'page' || key == 'rows') continue;
          this.condition[key] = '';
        }
      },
      completeSizeChange(rows) {
        this.condition.rows = rows;
        this._contractPageList();
      },
      completeCurrentChange(page) {
        this.condition.page = page;
        this._contractPageList();
      },
      // 补录合同 —— 选中合同
      contractChange(val) {
        this.selectContract = val;
      },
      // 完善价格 —— 确认
      async priceSetConfirm() {
        if (
          this.completeDate.type == 1 &&
          (!this.completeDate.price || this.completeDate.price == '')
        ) {
          return this.$message.warning('请输入价格！');
        }
        if (
          this.completeDate.type == 1 &&
          (!this.selectContract.id || this.selectContract.id == '')
        ) {
          return this.$message.warning('请选择合同！');
        }
        let obj = '?id=' + this.completeDate.id;
        if (this.completeDate.isWay != 1 && this.completeDate.type == 1) {
          obj += '&contractId=' + this.selectContract.id;
          obj += '&contractPrice=' + this.completeDate.price;
        }
        if (this.completeDate.isWay == -1 && this.completeDate.type == 2) {
          obj += '&preparePrice=' + this.completeDate.price;
          if (this.selectContract.id && this.selectContract.id != '') {
            obj += '&contractId=' + this.selectContract.id;
          }
        }
        if (this.completeDate.isEst && this.completeDate.estimate) {
          obj += '&estimatePrice=' + this.completeDate.estimate;
        }
        this.completeLoad = true;
        let res = await completeHighPrice(obj);
        this.completeLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this._lineConsignorLineList();
        this.priceSetVisible = false;
      },

      handleClick() {},
      //模板下载
      download() {
        window.location.href = '/file/公路供应商运费线路价格导入模板.xlsx';
      },
      // 批量导入
      planOnSuccess(res) {
        this.importLoading = false;
        this.$alert(res.message, '提示', {
          confirmButtonText: '关闭',
          callback: async () => {
            this.TableDatas = res.data;
            await this._lineConsignorLineList();
          },
        });
      },
      beforeUpload(file) {
        if (file.name.split('.')[1] == 'xls' || file.name.split('.')[1] == 'xlsx') {
          this.uploadData.mFile = file.name;
          this.importLoading = true;
        } else {
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
      //导出数据
      exportData() {
        // let token = getSessionStore('token');
        const {
          contractName,
          contractCode,
          highwayName,
          startAddressName,
          endAddressName,
          customerCarName,
          status,
          type,
        } = this.form;
        // window.location.href = `${baseUrl}/platform/price/highwayLine/highWayLinePriceExport?access_token=${token}&highwayName=${highwayName}&contractName=${contractName}&contractCode=${contractCode}&startAddressName=${startAddressName}&endAddressName=${endAddressName}&customerCarName=${customerCarName}&status=${status}&type=${type}`;
        window.exportExcelGet('/platform/price/highwayLine/highWayLinePriceExport', `highwayName=${highwayName}&contractName=${contractName}&contractCode=${contractCode}&startAddressName=${startAddressName}&endAddressName=${endAddressName}&customerCarName=${customerCarName}&status=${status}&type=${type}`)
      },
    },
  };
</script>

<style lang="scss" scoped>
  .highWayPrice {
    /*width:100%;*/
    padding: 0 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        .el-form-item {
          margin-bottom: 5px;
        }

        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    ::v-deep .detail {
      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;
      display: flex;
      flex-direction: column;

      .tabs {
        float: left;
        margin-left: 20px;
        margin-top: 2px;
        display: flex;
        justify-content: space-between;
        width: 239px;
        margin-bottom: 20px;

        div {
          //background: #ccc;
          width: 120px;
          height: 30px;
          line-height: 30px;
          color: #48599e;
          text-align: center;
          font-size: 13px;
          cursor: pointer;
          border: 1px solid #48599e;
          font-weight: 700;
          transition: all 0.3s;
        }

        .left {
          border-top-left-radius: 10px;
          border-bottom-left-radius: 10px;
        }

        .right {
          /*width: 160px;*/
          border-top-right-radius: 10px;
          border-bottom-right-radius: 10px;
        }

        .active {
          background: #48599e;
          color: #fff;
        }
      }

      .baseInfo {
        display: flex;
        flex-direction: column;

        .el-table td,
        .el-table th {
          padding: 0;
        }

        .el-table td .cell {
          font-weight: 400;
        }

        .cell {
          font-size: 10px;
          padding: 0;
          font-weight: 900;
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .el-form-item {
            margin-bottom: 2px;
            font-weight: 700;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          /*margin-top: 10px;*/
          padding: 20px;
        }
      }
    }
  }

  ::v-deep {
    .el-table__body tr.current-row > td {
      background-color: #409eff;
      color: #fff !important;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
      text-align: center;
    }

    .el-dialog__headerbtn {
      top: 0px;
      height: 42px;
      line-height: 42px;
      right: 10px;
      font-size: 20px;

      .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }
    }

    .el-dialog__title {
      color: #fff;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
    }

    span.el-icon-download.el-icon--right {
      font-size: 16px;
      text-decoration: underline;
    }

    span i.el-icon-upload.el-icon--right {
      font-size: 16px;
      text-decoration: underline;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #ffffff;
    }

    .el-dialog__headerbtn {
      top: 0px !important;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
      overflow: auto;
      max-height: 75vh;
      color: #606266;
    }

    .el-dialog__wrapper {
      top: -52px;
    }
  }

  .navBtn {
    display: inline-block;
    width: calc(100% - 690px);
    text-align: right;
    margin-bottom: 10px;
  }

  .navContainer {
    display: inline-block;
    width: 230px;
    text-align: center;

    p {
      display: inline-block;
      width: 70px;
    }

    ::v-deep {
      .transportTitle {
        z-index: 99;
      }

      .el-table__body tr.current-row > td {
        background-color: #409eff;
        color: #fff !important;
      }

      .cell .el-form-item {
        padding: 0 2px;
      }

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
        text-align: center;
      }

      .el-dialog__headerbtn {
        top: 0px;
        height: 42px;
        line-height: 42px;
        right: 10px;
        font-size: 20px;

        .el-dialog__close {
          color: #fff;
          font-size: 25px;
        }
      }

      .el-dialog__title {
        color: #fff;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
      }

      .el-dialog__body {
        padding: 20px !important;
        max-height: 60vh;
        overflow-y: auto;
      }
    }
  }
</style>
